// extracted by mini-css-extract-plugin
module.exports = {"header":"Gallery_header__3Ye8P","container":"Gallery_container__3q335","tab":"Gallery_tab__2AZ4z","button":"Gallery_button__1iwNs"};